import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.index-of.js";
import Cookie from '../utils/cookie';
import axios from 'axios';
import env from '../env';
import { passportUrl } from '../config/domain';
var isProd = env.isProduct || env.isPpe;
var UA = (navigator.userAgent + '').toLowerCase();
var getLocationByCmb = function getLocationByCmb() {
  return new Promise(function (resolve) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (pos) {
        return resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        });
      }, function () {
        return resolve({
          lat: 31.231706,
          lng: 121.472644
        });
      }, {
        timeout: 10000
      });
    } else {
      resolve({
        lat: 31.231706,
        lng: 121.472644
      });
    }
  });
};
export default {
  appName: 'icbc_elife',
  useKNB: false,
  sellChannel: 45,
  theme: 'maoyan',
  hostPrefix: '//show.maoyan.com/qqw',
  hostBetaPrefix: '//show.test.maoyan.com/qqw',
  ajaxUrl: '//show.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//show.test.maoyan.com/maoyansh/myshow/ajax',
  tokenCookie: 'token',
  linkMap: {
    // 地址跳转映射
    // 首页
    '/myshow/': '/',
    '/myshow/index.html': '/',
    '/movieshow/index.html': '/',
    // 列表相关
    '/movieshowlist/graphic-detail.html': '/graphic',
    '/movieshowlist/show-ticket.html': '/list',
    '/movieshowlist/show-merchant.html': '/merchants',
    '/movieshowlist/show-detail.html': '/detail',
    '/movieshowlist/group.html': '/group',
    '/movieshowlist/search.html': '/search',
    '/movieshowlist/show-shop.html': '/shop',
    // 下单相关
    '/movieshoworder/goods.html': '/tickets',
    '/movieshoworder/pre-order.html': '/confirm',
    '/movieshoworder/area.html': '/partition',
    '/movieshoworder/add-address.html': '/add-addr',
    '/movieshoworder/choose-address.html': '/choose-addr',
    '/movieshoworder/coupon-detail.html': '/coupon-detail',
    '/movieshoworder/seats.html': '/seats',
    '/movieshoworder/coupon.html': '/coupon',
    '/movieshoworder/order-detail.html': '/order-detail',
    '/movieshoworder/order-list.html': '/order-list',
    '/movieshoworder/real-names.html': '/realname',
    '/movieshoworder/seat-area.html': '/seat-area',
    '/movieshoworder/select-seats.html': '/select-seats',
    '/movieshoworder/search-order.html': '/search-order'
  },
  getLocation: function getLocation() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var localtion;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getLocationByCmb();
          case 3:
            localtion = _context.sent;
            return _context.abrupt("return", {
              lat: localtion.lat || 31.231706,
              lng: localtion.lng || 121.472644
            });
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.log('定位', _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }))();
  },
  getCity: function getCity() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var localtion, lat, lng, preUrl, instance, date, res, _res$data, code, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getLocationByCmb();
          case 2:
            localtion = _context2.sent;
            lat = localtion.lat || 31.231706;
            lng = localtion.lng || 121.472644;
            preUrl = isProd ? 'https://show.maoyan.com/maoyansh/myshow/ajax' : 'https://show.test.maoyan.com/maoyansh/myshow/ajax';
            instance = axios.create({
              baseURL: "".concat(preUrl),
              timeout: 15000
            });
            date = new Date().getTime();
            _context2.next = 10;
            return instance.get("/city/queryMTCity?lat=".concat(lat, "&lng=").concat(lng, "&sellchannel=45&t=").concat(date));
          case 10:
            res = _context2.sent;
            _res$data = res.data, code = _res$data.code, data = _res$data.data;
            if (!(code === 200)) {
              _context2.next = 17;
              break;
            }
            Cookie.set('cityid', data.id);
            return _context2.abrupt("return", {
              cityId: data.id,
              cityName: data.nm,
              pinyin: data.py
            });
          case 17:
            // 默认投放上海
            Cookie.set('cityid', 10);
            return _context2.abrupt("return", {
              cityId: 10,
              cityName: '上海',
              pinyin: 'shanghai'
            });
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  /**
   * 登录方法
   */
  login: function login() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var locationUrl, redirectURL, url;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            locationUrl = new URL(window.location.href);
            redirectURL = locationUrl.toString(); // 跳转登录页面
            url = "".concat(passportUrl, "/bankLogin?appName=ICBC&redirectURL=").concat(encodeURIComponent(redirectURL));
            _context3.next = 6;
            return new Promise(function (r) {
              return setTimeout(r, 2000);
            });
          case 6:
            if (!(location.hostname.indexOf('maoyan') >= 0)) {
              _context3.next = 10;
              break;
            }
            location.href = url;
            _context3.next = 11;
            break;
          case 10:
            return _context3.abrupt("return", Promise.reject(new Error('不支持当前域名')));
          case 11:
            _context3.next = 16;
            break;
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", Promise.reject(new Error('小喵提醒您，请返回入口后再次进入')));
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 13]]);
    }))();
  }
};